import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DesignSystemComponentsModule } from '@montebravo.tech/design-system-components';
import { DesignSystemCoreModule } from '@montebravo.tech/design-system-core';
import { IconComponent } from '@montebravo.tech/design-system-icons';
import { PipesSharedModule } from '../../pipes/pipes-shared.module';
import { UploadFileModule } from '../upload-file/upload-file.module';
import { UploadFileMultiTabModule } from '../upload-file-multi-tab/upload-file-multi-tab.module';
import { UploadViewComponentComponent } from './upload-view-component.component';

@NgModule({
    declarations: [UploadViewComponentComponent],
    imports: [
        CommonModule,
        PipesSharedModule,
        UploadFileModule,
        UploadFileMultiTabModule,
        DesignSystemCoreModule,
        DesignSystemComponentsModule,
        IconComponent,
    ],
    exports: [UploadViewComponentComponent],
})
export class UploadViewComponentModule {}
